const handleAlphabeticCheck = (event) => {
    if (
      (event.charCode >= 65 && event.charCode <= 90) || // Uppercase letters
      (event.charCode >= 97 && event.charCode <= 122)|| // Lowercase letters
      event.charCode === 32 // Space
    ) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  };
  
  export default handleAlphabeticCheck;
  